import React from "react";
import PropTypes from "prop-types";

const STATUS_COLORS = {
  present: "#4ee474",
  absent: "#FF5733",
  checkedIn: "#4ee474",
  notCheckedIn: "#FF5733",
};

export default function StatusIndicator({ status, size = "1.2rem", className = "" }) {
  const backgroundColor = STATUS_COLORS[status] || STATUS_COLORS.absent;

  return (
    <span
      className={className}
      style={{
        background: backgroundColor,
        borderRadius: "50%",
        width: size,
        height: size,
        display: "inline-block",
        verticalAlign: "text-bottom",
      }}
    />
  );
}

StatusIndicator.propTypes = {
  status: PropTypes.oneOf(["present", "absent", "checkedIn", "notCheckedIn"]).isRequired,
  size: PropTypes.string,
  className: PropTypes.string,
};
